(()=> {
    class TutorialsSelect extends HTMLElement {
        constructor() {
            super();
            this.tabs = [];
            this.cards = [];
            this.activeTab = null;
        }

        connectedCallback() {
            const urlParams = new URLSearchParams(window.location.search);
            const paramTab = urlParams.get("tab");

            const selectedTabEl = this.querySelector(".Toggle__tab[data-selected]");
            this.activeTab = paramTab || (selectedTabEl ? selectedTabEl.dataset.selected : null);

            this.tabs = Array.from(this.querySelectorAll(".Toggle__tab"));
            this.cards = Array.from(this.querySelectorAll(".Loop--tutorials, .Loop--faqTabs, .Loop--productTabs"));

            this.bindEvents();
            this.activateTab(this.activeTab);

            window.addEventListener("popstate", (event) => {
                const tabId =
                    (event.state && event.state.tabId) ||
                    new URL(window.location.href).searchParams.get("tab") ||
                    (this.querySelector(".Toggle__tab[data-selected]")?.dataset.selected || null);
                this.activateTab(tabId, false);
            });
        }

        bindEvents() {
            this.tabs.forEach((tab) => {
                tab.addEventListener("click", () => {
                    const selectedCategory = tab.dataset.category;
                    this.activateTab(selectedCategory, true);
                });
            });
        }

        activateTab(tabId, updateUrl = false) {
            if (!tabId) return;

            this.tabs.forEach((t) => t.classList.toggle("is-selected", t.dataset.category === tabId));

            const activeTab = this.tabs.find((t) => t.dataset.category === tabId);
            // Smooth when the user clicked, instant on first paint / back-forward.
            if (activeTab) this.scrollTabIntoView(activeTab, updateUrl);

            this.cards.forEach((card) => {
                const isMatch = card.dataset.category === tabId;
                card.style.display = isMatch ? "block" : "none";
                card.classList.toggle("is-selected", isMatch);
            });

            if (updateUrl) {
                const newUrl = new URL(window.location.href);
                newUrl.searchParams.set("tab", tabId);
                history.pushState({ tabId }, "", newUrl.toString());
            }

            this.activeTab = tabId;
        }

        // Bring the active tab into view when the tab bar scrolls horizontally.
        // No-ops when the bar doesn't overflow, so the videos page is unaffected.
        scrollTabIntoView(tab, smooth) {
            const bar = tab.closest(".Carrier__toggle");
            if (!bar || bar.scrollWidth <= bar.clientWidth) return;

            const barRect = bar.getBoundingClientRect();
            const tabRect = tab.getBoundingClientRect();

            // Already fully visible — leave the scroll position alone.
            if (tabRect.left >= barRect.left - 1 && tabRect.right <= barRect.right + 1) return;

            // Centre it, clamped to the scrollable range. Matches scroll-snap-align: center.
            const offset = tabRect.left - barRect.left - (bar.clientWidth - tabRect.width) / 2;
            const left = Math.max(0, Math.min(bar.scrollLeft + offset, bar.scrollWidth - bar.clientWidth));

            bar.scrollTo({ left: left, behavior: smooth ? "smooth" : "instant" });
        }
    }

    customElements.define('tutorials-select', TutorialsSelect);
})()